/**
 * Who is signed in on this client.
 */
export enum SessionKindEnum {
  ANONYMOUS = 'anonymous',
  OPERATOR = 'operator',
  RENTER = 'renter',
}
